<div
  [class.rms-layout-footer-enabled]="isFooterVisible$ | async"
  [class.rms-layout-scroll-disabled]="scrollDisabled$ | async"
  [class.rms-layout-sidenav-collapsed]="sidenavCollapsed$ | async"
  class="rms-base-layout-container rms-layout-horizontal">
  <ng-content />
</div>
